import { defineStore } from "pinia";
import { ref } from "vue";

export const useTermsConsentStore = defineStore('termsConsent', () => {
  const orderTermsConsent = ref(false);
  const returnTermsConsent = ref(false);
  const barcodeScanConsent = ref(false);
  const enifClubConsent = ref(false);

  const setConsent = (key) => {
    if (key === 'orderTerms') orderTermsConsent.value = true;
    if (key === 'returnTerms') returnTermsConsent.value = true;
    if (key === 'barcodeScanTerms') barcodeScanConsent.value = true;
    if (key === 'enifClubTerms') enifClubConsent.value = true;
  };

  const resetConsent = (key) => {
    if (key === 'orderTerms') orderTermsConsent.value = false;
    if (key === 'returnTerms') returnTermsConsent.value = false;
    if (key === 'barcodeScanTerms') barcodeScanConsent.value = false;
    if (key === 'enifClubTerms') enifClubConsent.value = false;
  }

  return {
    orderTermsConsent
    , returnTermsConsent
    , barcodeScanConsent
    , enifClubConsent
    , setConsent
    , resetConsent
  }
})